import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';
    // class definition
    OndigoNS.FormEnhancement = function () {
        this.init();
    };

    OndigoNS.FormEnhancement.prototype = {
        init: function () {
            var clicked = false;

            // icon above submit button click fix
            $('.buttonWrap').on('click', function (e) {
                if (!clicked) {
                    clicked = true;
                    $('.button', $(this)).click();

                    //prevent recursion
                    window.setTimeout(function () {
                        clicked = false;
                    }, 10);
                }
            });

            $('input[placeholder], textarea[placeholder]').each(function () {
                var $this = $(this);
                if ($this.val() === '') {
                    $this.val($this.attr('placeholder')).focus(function () {
                        $this.val('');
                    }).blur(function () {
                        if ($this.val() === '' || $this.val() === $this.data('error-notempty')) {
                            $this.val($this.attr('placeholder'));
                        }
                    });
                }
            });

            var $forms = $('.ondigoform form'),
              $select = $('select', $forms),
              $textInputs = $('input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="button"]), textarea', $forms),
              $radio = $('input[type="radio"]', $forms);

            $forms.each(function(i, form) {
                // sehr stranger firefox bugfix. Wenn der Button durch Absenden disabled wird, ist er auch nach dem Neuladen noch disabled.
                $(form).find('.buttonWrap input').removeAttr('disabled');
            });

            $textInputs.on('focus', function () {
                var $this = $(this);
                window.setTimeout(function () {
                    $this.closest('.row').addClass('hasValue');
                });
            }).on('focusout', function () {
                var $this = $(this);
                window.setTimeout(function () {
                    if ($this.val() === '') {
                        $this.closest('.row').removeClass('hasValue');
                        $this.closest('.row').removeClass('filled');
                    } else {
                        $this.closest('.row').addClass('filled');
                    }
                });
            });

            $textInputs.each(function() {
                var $this = $(this);

                if ($this.val() !== '') {
                    $this.closest('.row').addClass('hasValue');
                }
                else {
                    $this.closest('.row').removeClass('hasValue');
                }
            });

            $select.each(function() {
                var $this = $(this);

                if($this.find('option:selected').val() !== '') {
                    $this.closest('.row').addClass('hasValue');
                } else {
                    $this.closest('.row').removeClass('hasValue');
                }
            });

            $select.on('change', function (e) {
                var $this = $(this);

                if($this.find('option:selected').val() !== '') {
                    $this.closest('.row').addClass('hasValue');
                    $this.closest('.row').addClass('filled');
                } else {
                    $this.closest('.row').removeClass('hasValue');
                    $this.closest('.row').removeClass('filled');
                }
            });
        }
    };
    // plugin definition
    $.fn.formEnhancement = function () {
        return new OndigoNS.FormEnhancement();
    };
    $.fn.formEnhancement.Constructor = OndigoNS.FormEnhancement;

}(window.jQuery));

$(document).ready(function () {
    'use strict';

    $.fn.formEnhancement();
});